import React from 'react';
import { Body, Modal } from '@icarros/ids-react';
import { ModalBody } from './style';

interface HowToPricesModalProps {
  modalOpen: boolean;
  setModalOpen(value: boolean): void;
}

export function HowToPrices({ modalOpen, setModalOpen }: HowToPricesModalProps): JSX.Element {
  return (
    <Modal
      stateOpen={[modalOpen, setModalOpen]}
      body={
        <ModalBody>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Para definir o preço do seu carro, busque considerar o ano, quilometragem atualizada e
            danos causados (lataria amassada, banco rasgado, pneu careca, entre outros).
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            Você pode usar os critérios indicados e fazer uma base com a tabela disponível:
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            <b>Mínimo</b>: preço mínimo que seu veículo pode ser anunciado no iCarros.
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            <b>Média iCarros</b>: valor médio dos anúncios cadastrados no site.
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            <b>Tabela Fipe</b>: preços médios de veículos no mercado nacional.
          </Body>
          <Body size="body_2" contrast="default" weight="regular" variant="base">
            <b>Modelos similares</b>: valor médio de modelos parecidos com o seu (considerando
            modelo e ano).
          </Body>
        </ModalBody>
      }
      title="como precificar o seu veículo"
      mainButtonText="entendi"
      mainButtonMethod={() => setModalOpen(false)}
    />
  );
}
